<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-manual-control d-lg-inline-block"></div>

            <section class="content site-cgu">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="request-title">
                                <h1> Conditions Générales d'Utilisation</h1>
                            </div>

                            <div v-if="siteCgu.length > 0" v-html="siteCgu">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../components/Sidebar';
    import Footer from '../components/Footer';
    import { fetchDueLegalInformation } from '@/service/api/dues.api';

    export default {
        data() {
            return {
                siteCgu: []
            };
        },
        async created() {
            await this.fetchDueLegalInformation();
        },
        methods: {
            async fetchDueLegalInformation() {
                let { data } = await fetchDueLegalInformation();

                this.siteCgu = data.siteGeneralConditionsOfUsageLegalAdviceText.legalAdvice;
            }
        },
        components: {
            Sidebar,
            Footer
        }
    }
</script>
